export class EnrichmentDescription {

    public url:String ="";
    public key:String ="";
   
    
}



// WEBPACK FOOTER //
// ./src/app/shared/models/enrichmentDescription.ts